export default {
      id: "help-bubble-down-usage",
      viewBox: "0 0 66 75",
      url: "/" + "sprite.svg#help-bubble-down",
      toString: function () {
        return this.url;
      }
    }